import React, { useEffect, useState } from 'react';
import { Alert, Button, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { getDeliverySettings } from '../../../API/PhishingAPI';

export default function CampaignLinkDomainSelect({ domainId = '', value = '', onChange, onOpenSettings, error, t }) {
  const [state, setState] = useState({ loading: true, error: false, catalog: null });
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    setState({ loading: true, error: false, catalog: null });
    getDeliverySettings().then(catalog => {
      if (!Array.isArray(catalog?.linkDomains)) throw new Error('Campaign link domains unavailable');
      if (active) setState({ loading: false, error: false, catalog });
    }).catch(() => { if (active) setState({ loading: false, error: true, catalog: null }); });
    return () => { active = false; };
  }, [revision]);
  const available = state.catalog?.linkDomains.filter(domain => domain.enabled) || [];
  const selected = available.find(domain => domain.id === domainId) || available.find(domain => domain.url === value)
    || available.find(domain => domain.id === state.catalog?.defaultLinkDomainId) || available[0];
  useEffect(() => {
    if (!state.loading) onChange(state.error ? null : selected || null);
  }, [state.loading, state.error, selected, onChange]);

  return <FormGroup className="campaign-link-domain">
    <Label for="campaign-link-domain">{t('campaign_link_domains.field_label')}</Label>
    {state.loading ? <p role="status"><Spinner tag="span" size="sm" /> {t('campaign_link_domains.loading')}</p>
      : state.error ? <Alert color="danger" role="alert">{t('campaign_link_domains.load_error')}{' '}
        <Button color="link" onClick={() => setRevision(current => current + 1)}>{t('template_gallery.retry')}</Button></Alert>
        : !available.length ? <Alert color="info">{t('campaign_link_domains.none_available')}{' '}
          <Button color="link" onClick={() => setRevision(current => current + 1)}>{t('campaign_link_domains.refresh')}</Button>
          {onOpenSettings && <Button color="link" onClick={onOpenSettings}>{t('delivery_settings.view_settings')}</Button>}</Alert>
          : available.length === 1 ? <Input id="campaign-link-domain" type="url" value={selected.url} readOnly aria-describedby="campaign-link-domain-help" />
            : <Input id="campaign-link-domain" type="select" value={selected?.id || ''} aria-describedby="campaign-link-domain-help"
              onChange={event => onChange(available.find(domain => domain.id === event.target.value))}>
              {available.map(domain => <option key={domain.id} value={domain.id}>{domain.label} — {domain.url}{domain.id === state.catalog.defaultLinkDomainId ? ` (${t('campaign_link_domains.default')})` : ''}</option>)}
            </Input>}
    <small id="campaign-link-domain-help" className="d-block text-muted mt-2">{t('campaign_link_domains.help')}</small>
    {error && <small className="text-danger">{error}</small>}
  </FormGroup>;
}
